// Treatment-related thunks
import { dispatch, store } from '../../store';
import { updateError } from '../user';
import { callApi } from '../../../utils/apiCall';
import { errorHandler } from '../../../utils/errorHandler';
import { getCurrentTreatmentIdV2, getPracticeId } from '../clincheck';
import { setLoader } from '../loader';
import { leadActions, startLoadingData, updateCompleteStatus, startLoadingDepositPending } from './slice';

import { followUpSlice, addAppointment, UpdateAppointment } from './appointmentThunks';

export function addTreatment(detail, practiceId, id, handleClose, teethData, isAddTreatmentWhileBooking) {
    return async () => {
        try {
            const { lead, newLeadDetail } = store.getState().lead;
            let response;
            if (detail?.treatment)
                response = await callApi(`/api/v1/practices/${practiceId}/leads/${id}/treatments/`, 'post', detail);
            else {
                dispatch(updateCompleteStatus(false));
                dispatch(startLoadingData(false));
                handleClose();
                return;
            }
            if (response?.status === 201) {
                const results = [];
                const { data } = response;
                lead?.results.forEach(el => {
                    const detail = { ...el };
                    if (el?.id === data?.lead) {
                        detail.lead_treatments = [data];
                    }
                    results.push(detail);
                });
                const close = (status, id) => handleClose(status, id, data?.id);
                dispatch(leadActions.updateLead({ results, count: lead.count }));
                dispatch(leadActions.saveTreatment(response.data));
                if (isAddTreatmentWhileBooking) {
                    dispatch(leadActions.updateLeadTreatment([data]));
                    dispatch(updateError({ message: "Treatment Added Successfully", success: true }));
                    setTimeout(() => {
                        handleClose();
                    }, 500);
                    return;
                }
                if (newLeadDetail?.addAppointment) {
                    const appointmentDetail = {
                        ...newLeadDetail.lead_appointment,
                        lead_treatment: response.data.id
                    };
                    dispatch(addAppointment(appointmentDetail, practiceId, id, close, 'CreatLead'));
                    if (newLeadDetail?.attentendAppoiment?.activeTab === 'Starting treatment') return;
                    if (!teethData?.needToUpdate) return;
                }
                if (teethData?.needToUpdate) {
                    const updateTreatment = {
                        ...detail,
                        lead: id,
                        id: data.id,
                    };
                    updateTreatment.leadtreatment_specification = {
                        lead_treatment: data.id,
                        teeth_count: teethData?.teeth
                    };
                    dispatch(editTreatment(updateTreatment, close, 'editTreatment'));
                } else {
                    handleClose('finish', id, data.id);
                    dispatch(startLoadingData(false));
                }
                dispatch(updateError({ message: 'Treatment added successfully', success: true }));
                return;
            }
            dispatch(updateCompleteStatus(false));
            dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
            dispatch(startLoadingData(false));
        } catch (error) {
            dispatch(updateCompleteStatus(false));
            dispatch(updateError({ message: JSON.stringify(error.message) || 'Something went wrong', success: false }));
            dispatch(startLoadingData(false));
        }
    };
}

export function UpdateTreatmentV2(data, practiceId, handleClose, status) {
    return async () => {
        try {
            let detail = {
                ...data
            };
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${data?.lead}/treatments/${data.id}/`);
            if (response?.status === 200) {
                if (response?.data?.leadtreatment_specification?.id) {
                    detail = {
                        ...detail,
                        leadtreatment_specification: {
                            teeth_count: detail?.teethAmount || 0
                        }
                    };
                } else {
                    detail = {
                        ...detail,
                        leadtreatment_specification: {
                            lead_treatment: data.id,
                            teeth_count: detail?.teethAmount || 0
                        }
                    };
                }
                dispatch(editTreatment(detail, handleClose, status));
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message), success: false }));
        }
    };
}
export function UpdateTreatmentV3(data, type, handleSuccess) {
    return async () => {
        try {
            let detail = {
                ...data.detail
            };
            const practiceId = getPracticeId();
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${data?.lead_id}/treatments/${data.treatment_id}/`);
            if (response?.status === 200) {
                if (response?.data?.leadtreatment_specification?.id) {
                    detail = {
                        ...detail,
                        leadtreatment_specification: {
                            teeth_count: detail?.teethAmount || 0
                        }
                    };
                } else {
                    detail = {
                        ...detail,
                        leadtreatment_specification: {
                            lead_treatment: data.treatment_id,
                            teeth_count: detail?.teethAmount || 0
                        }
                    };
                }
                dispatch(updateTreatmentDetail(practiceId, data?.lead_id, data?.treatment_id, detail, handleSuccess, type));
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message), success: false }));
        }
    };
}
export function UpdateTreatment(data, practiceId, handleClose, status) {
    return async () => {
        try {
            const detail = {
                ...data
            };
            delete detail.lead;
            delete detail.id;

            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${data?.lead}/treatments/${data.id}/`, 'put', detail);
            if (response?.status === 200) {
                const { newLeadDetail: { startTreatment, lead_appointment: leadAppointments }, createLead, tableRowLead, followLead } = store.getState().lead;
                if (status === 'RescheduleTreatment') {
                    if (tableRowLead?.status === 'FAILED_TO_ATTEND_CONSULTATION' || tableRowLead?.status === 'FAILED_TO_ATTEND') {
                        dispatch(addAppointment(startTreatment?.appointmentDetail, practiceId, createLead.id, handleClose, 'Reschedule'));
                        return;
                    }
                    dispatch(UpdateAppointment(startTreatment?.appointmentDetail, practiceId, handleClose, 'Reschedule'));
                    return;
                }
                if (status === 'updateLeadDetail') {
                    const leadId = createLead.lead_treatment?.lead || followLead?.id || createLead.id;
                    const appointmentDetail = {
                        ...leadAppointments,
                        lead_treatment: createLead.lead_treatment.id,
                    };
                    dispatch(addAppointment(appointmentDetail, practiceId, leadId, handleClose, 'followUp'));
                    return;
                }
                if (status === 'editTreatment') {
                    dispatch(updateError({ success: true, message: 'Treatment updated successfully' }));
                    dispatch(startLoadingData(false));
                    handleClose('finish', data?.lead);
                    return;
                }
                const { practice } = store.getState().practice;
                const isPaymentMandatory = practice?.preferences?.is_payment_enforced_before_treatment;
                if (isPaymentMandatory && data.depositStatus) return;
                const startTreatments = {
                    ...startTreatment.updatedTreatment,
                    lead: data?.lead,
                    id: data.id
                };
                dispatch(StartingTreatment(startTreatments, practiceId, handleClose, status));
                return;
            }
            dispatch(updateCompleteStatus(false));
            dispatch(updateError({ message: JSON.stringify(response.data || response.detail), success: false }));
            dispatch(startLoadingData(false));
            document.body.classList.remove('points-event');
        } catch (error) {
            dispatch(updateCompleteStatus(false));
            dispatch(updateError({ message: JSON.stringify(error.message), success: false }));
            dispatch(startLoadingData(false));
        }
    };
}

export function editTreatment(data, handleClose, status) {
    return async () => {
        try {
            const detail = {
                ...data
            };
            delete detail.lead;
            delete detail.id;
            const practiceId = getPracticeId();
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${data?.lead}/treatments/${data.id}/`, 'PATCH', detail);
            if (response?.status === 200) {
                const { newLeadDetail: { startTreatment, lead_appointment: leadAppointments }, createLead, tableRowLead, followLead } = store.getState().lead;
                if (status === 'RescheduleTreatment') {
                    if (tableRowLead?.status === 'FAILED_TO_ATTEND_CONSULTATION' || tableRowLead?.status === 'FAILED_TO_ATTEND') {
                        dispatch(addAppointment(startTreatment?.appointmentDetail, practiceId, createLead.id, handleClose, 'Reschedule'));
                        return;
                    }
                    dispatch(UpdateAppointment(startTreatment?.appointmentDetail, practiceId, handleClose, 'Reschedule'));
                    return;
                }
                if (status === 'updateLeadDetail') {
                    const leadId = createLead.lead_treatment?.lead || followLead?.id || createLead.id;
                    const appointmentDetail = {
                        ...leadAppointments,
                        lead_treatment: createLead.lead_treatment.id,
                    };
                    dispatch(addAppointment(appointmentDetail, practiceId, leadId, handleClose, 'followUp'));
                    return;
                }
                if (status === 'editTreatment') {
                    dispatch(updateError({ success: true, message: 'Treatment updated successfully' }));
                    dispatch(startLoadingData(false));
                    handleClose('finish', data?.lead);
                    return;
                }
                const { practice } = store.getState().practice;
                const isPaymentMandatory = practice?.preferences?.is_payment_enforced_before_treatment;
                if (isPaymentMandatory && data.depositStatus) return;
                const startTreatments = {
                    ...startTreatment.updatedTreatment,
                    lead: data?.lead,
                    id: data.id
                };
                dispatch(StartingTreatment(startTreatments, practiceId, handleClose, status));
                return;
            }
            dispatch(updateCompleteStatus(false));
            dispatch(updateError({ message: JSON.stringify(response.data || response.detail), success: false }));
            dispatch(startLoadingData(false));
            dispatch(setLoader(false));
            document.body.classList.remove('points-event');
        } catch (error) {
            dispatch(updateCompleteStatus(false));
            dispatch(updateError({ message: JSON.stringify(error.message), success: false }));
            dispatch(startLoadingData(false));
            dispatch(setLoader(false));
        }
    };
}

export function CompleteTreatment(data, leadId, id, practiceId, handleClose) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/treatments/${id}/treatment_closed/`, 'post', data);
            if (response?.status === 200) {
                dispatch(updateError({ success: true, message: 'Treatment completed successfully' }));
                dispatch(updateCompleteStatus(false));
                handleClose('finish', leadId);
                dispatch(startLoadingData(false));
                return;
            }
            dispatch(setLoader(false));
            dispatch(updateCompleteStatus(false));
            dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
            dispatch(startLoadingData(false));
        } catch (error) {
            dispatch(setLoader(false));
            dispatch(updateCompleteStatus(false));
            errorHandler(error, '', updateError);
            dispatch(startLoadingData(false));
        }
    };
}

export function StartingTreatment(data, practiceId, handleClose, status) {
    return async () => {
        try {
            const treatmentDetail = {
                ...data,
            };
            delete treatmentDetail.lead;
            delete treatmentDetail.id;
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${data?.lead}/treatments/${getCurrentTreatmentIdV2(data.id)}/treatment_started/`, 'post', treatmentDetail);
            if (response?.status === 200) {
                if (status === 'startingTreatmentFinish') {
                    dispatch(updateError({ success: true, message: 'Treatment started successfully' }));
                    dispatch(updateCompleteStatus(false));
                    handleClose('finish', getCurrentTreatmentIdV2(data.id));
                    dispatch(startLoadingData(false));
                    return;
                }
                const {
                    newLeadDetail: {
                        startTreatment,
                    },
                    createLead
                } = store.getState().lead;
                const appointmentDetail = {
                    ...startTreatment.appointmentDetail,
                    lead_treatment: createLead.lead_treatment.id,
                };
                if (appointmentDetail.datetime) {
                    dispatch(addAppointment(appointmentDetail, practiceId, data?.lead, handleClose, status));
                    return;
                }
                dispatch(updateError({ success: true, message: 'Treatment started successfully' }));
                dispatch(updateCompleteStatus(false));
                handleClose('finish', data?.lead);
                dispatch(startLoadingData(false));
                return;
            }
            dispatch(setLoader(false));
            dispatch(updateCompleteStatus(false));
            dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
            dispatch(leadActions.hasError(response.data || 'Something went wrong'));
        } catch (error) {
            dispatch(setLoader(false));
            dispatch(updateCompleteStatus(false));
            dispatch(updateError({ message: JSON.stringify(error.message), success: false }));
            dispatch(leadActions.hasError(error.message));
        }
    };
}

export function updateTreatmentDetail(practiceId, leadId, id, detail, handleSuccess, type, handleReloadAPI) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/treatments/${id}/`, 'patch', detail);
            if (response?.status === 200) {
                if (handleReloadAPI) {
                    handleReloadAPI('finish');
                }
                if (type === 'leadDataGrid') {
                    dispatch(updateError({ success: true, message: 'Treatment updated successfully' }));
                    return;
                }
                if (type === 'deposit_cell') {
                    handleSuccess({ success: true, message: 'Deposit status updated successfully', updateTreatment: true, event: type });
                    return;
                }
                if (type === 'choice_cell') {
                    handleSuccess({ success: true, message: 'Lead updated successfully', updateTreatment: true, event: type });
                    return;
                }
                handleSuccess({ success: true, message: 'Treatment updated successfully', updateTreatment: true, event: type });
            } else {
                dispatch(updateError({ message: JSON.stringify(response?.data) || 'Something went wrong', success: false }));
                dispatch(setLoader(false));
            }
        } catch (error) {
            handleSuccess({ success: false, message: error.message || 'Something went wrong' });
            dispatch(leadActions.hasError(error.message));
            dispatch(setLoader(false));
        }
    };
}

export function deleteTreatment(practiceId, leadId, id, handleNext) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/treatments/${id}/`, 'delete');
            if (response?.status === 204) {
                handleNext?.({ success: true, message: 'Treatment deleted successfully', cancelTreatment: true });
                dispatch(followUpSlice(leadId, practiceId, 'LeadDetail'));
            } else {
                const message = response?.data && typeof response.data === 'object'
                    ? Object.entries(response.data).map(([k, v]) => `${k}: ${v}`).join(', ')
                    : response?.data?.detail || `Failed to delete treatment (HTTP ${response?.status || 'timeout'})`;
                handleNext?.({ message, success: false });
                dispatch(leadActions.hasError(message));
            }
        } catch (error) {
            handleNext?.({ success: false, message: error.message || 'Something went wrong' });
            dispatch(leadActions.hasError(error.message));
        }
    };
}

export function getIndividualTreatment(data, handleClose) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${getPracticeId()}/leads/${data?.leadId}/treatments/${data.treatmentId}/`);
            dispatch(leadActions.setTreatmentLoading(false));
            if (response?.status === 200) {
                dispatch(leadActions.setCurrentTreatmentData(response?.data));
                if (handleClose) {
                    handleClose();
                }
                return;
            }
            dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
        } catch (error) {
            dispatch(leadActions.setTreatmentLoading(false));
            dispatch(updateError({ message: JSON.stringify(error.message), success: false }));
        }
    };
}

export function UpdateDepositPendingStatus(data, handleClose) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${getPracticeId()}/leads/${data?.leadId}/treatments/${data.treatmentId}/`, 'put', data?.payload);
            if (response?.status === 200) {
                dispatch(leadActions.setCurrentTreatmentData(response?.data));
                if (handleClose) {
                    handleClose();
                } else {
                    dispatch(leadActions.setTreatmentLoading(false));
                }
                dispatch(updateError({ message: JSON.stringify('Deposit status updated successfully'), success: true }));
                return;
            }
            dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
            dispatch(startLoadingDepositPending(false));
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message), success: false }));
            dispatch(startLoadingDepositPending(false));
        }
    };
}

export function consultationAttended(practiceId, leadId, id, handleSuccess, type) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/treatments/${id}/consultation_attended/`, 'post');
            if (response?.status === 200) {
                if (type === 'TreatmentAccordion') {
                    handleSuccess({ success: true });
                    dispatch(startLoadingData(false));
                    return;
                }
                handleSuccess({ success: true, message: 'Lead status updated successfully' });
            } else {
                dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message) || 'Something went wrong', success: false }));
            dispatch(updateCompleteStatus(false));
        }
    };
}

export function alignerApproveStatusMail(data, handleSuccess) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/leads-aligner-approve/update-status/`, 'post', data);
            if (response?.status === 200) {
                handleSuccess({ success: true, message: 'Aligner approve status updated successfully' });
            } else {
                handleSuccess({ success: false, message: JSON.stringify(response?.data) || 'Something went wrong' });
            }
        } catch (error) {
            handleSuccess({ success: false, message: error.message || 'Something went wrong' });
        }
    };
}
